import { TextInput } from "app/components/FormInputs/FormInputs";
import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import ManageFundingDepositDetails from "app/screens/ManageFundingScreen/components/ManageFundingDepositDetails/ManageFundingDepositDetails";
import { UserType } from "app/types/userType";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
// test
type Props = {
  onSubmit: (...args: Array<any>) => any;
  tab: string;
  I18n: any;
  handleChange: (...args: Array<any>) => any;
  emailError: string;
  amountError: string;
  formSubmitted: boolean;
  otherError: string;
  user: UserType;
};
// TabTypes
export const TabTypes = {
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
};

class NetellerFundingContent extends Component<Props> {
  render(): React.ReactElement<React.ComponentProps<"div">, "div"> {
    const {
      onSubmit,
      tab,
      I18n,
      handleChange,
      emailError,
      amountError,
      formSubmitted,
      otherError,
      user,
    } = this.props;

    return (
      <div className="neteller-funding__content">
        {tab === TabTypes.DEPOSIT && (
          <ManageFundingDepositDetails user={user} />
        )}
        <form onSubmit={onSubmit}>
          {tab === TabTypes.WITHDRAW && (
            <React.Fragment>
              <TextInput
                type="text"
                id="withdrawalEmail"
                label={I18n.email}
                onChange={handleChange}
              />
              <div className="error-msg">{emailError}</div>
            </React.Fragment>
          )}
          {tab === TabTypes.DEPOSIT && (
            <React.Fragment>
              <TextInput
                type="text"
                id="email"
                label={I18n.email}
                onChange={handleChange}
              />
              <div className="error-msg">{emailError}</div>
            </React.Fragment>
          )}
          <TextInput
            type="text"
            id="amount"
            label={I18n.amount}
            onChange={handleChange}
          />
          <div className="error-msg">{amountError}</div>
          {formSubmitted ? (
            <LoadingSpinner />
          ) : (
            <button disabled={formSubmitted} id="deposit_button" type="submit">
              {tab === TabTypes.DEPOSIT && (
                <FormattedMessage tagName="span" id="cashier-deposit-button" />
              )}
              {tab === TabTypes.WITHDRAW && (
                <FormattedMessage tagName="span" id="cashier-withdraw-button" />
              )}
            </button>
          )}
          <div className="error-msg">{otherError}</div>
        </form>
        <div className="neteller-funding__content__links">
          <a href="http://www.neteller.com" target="_new">
            <FormattedMessage tagName="span" id="cashier-createaccount" />
          </a>
        </div>
      </div>
    );
  }
}

export default NetellerFundingContent;
